"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequireAuth = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const AuthProvider_1 = require("../../providers/AuthProvider");
const RequireAuth = ({ children }) => {
    const { user, loading } = (0, AuthProvider_1.useAuth)();
    if (loading) {
        return null;
    }
    if (!user) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/login", replace: true });
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.RequireAuth = RequireAuth;
